import React from "react";
import img1 from "./Images/Frenjos-logo.png";

export default function Images() {
  return (
    <div className="Images">
      <img src={img1} alt="Logo" width="80"></img>
    </div>
  );
}
